(function () {
  if (window.mcmCartUpsellBound) return;
  window.mcmCartUpsellBound = true;

  function rootOf(node) {
    return node && node.closest('.mcm-cart-upsell');
  }

  function scrollerOf(root) {
    return root && root.querySelector('[data-mcm-upsell-scroller]');
  }

  function stepSize(scroller) {
    var slide = scroller.querySelector('.mcm-cart-upsell__item');
    if (!slide) return scroller.clientWidth;
    var styles = getComputedStyle(scroller);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function updateNav(root) {
    if (!root || !root.closest('.cart-drawer')) return;
    var scroller = scrollerOf(root);
    var prev = root.querySelector('[data-mcm-upsell-prev]');
    var next = root.querySelector('[data-mcm-upsell-next]');
    if (!scroller || !prev || !next) return;
    var max = scroller.scrollWidth - scroller.clientWidth - 2;
    var canScroll = max > 2;
    root.classList.toggle('is-static', !canScroll);
    prev.disabled = !canScroll || scroller.scrollLeft <= 2;
    next.disabled = !canScroll || scroller.scrollLeft >= max;
  }

  function updateAll() {
    document.querySelectorAll('.cart-drawer .mcm-cart-upsell').forEach(updateNav);
    document.querySelectorAll('[data-mcm-drawer-recs]').forEach(updateRecsNav);
  }

  function updateRecsNav(root) {
    if (!root) return;
    var scroller = root.querySelector('[data-mcm-drawer-recs-list]');
    var prev = root.querySelector('[data-mcm-drawer-recs-prev]');
    var next = root.querySelector('[data-mcm-drawer-recs-next]');
    if (!scroller || !prev || !next) return;
    var max = scroller.scrollWidth - scroller.clientWidth - 2;
    var canScroll = max > 2;
    root.classList.toggle('is-static', !canScroll);
    prev.disabled = !canScroll || scroller.scrollLeft <= 2;
    next.disabled = !canScroll || scroller.scrollLeft >= max;
  }

  function cartContext(mount) {
    var el = mount.querySelector('[data-mcm-drawer-recs-cart]');
    try {
      var data = JSON.parse(el.textContent);
      if (!Array.isArray(data)) return [];
      return data.map(function (item) {
        if (typeof item === 'string') return { handle: item, title: '', product_type: '', colours: [], upsell_handle: '' };
        return item;
      });
    } catch (error) {
      return [];
    }
  }

  function paintRecs(mount, html) {
    if (!mount.isConnected) return;
    var list = mount.querySelector('[data-mcm-drawer-recs-list]');
    if (!list) return;
    if (!html) {
      mount.hidden = true;
      return;
    }
    list.innerHTML = html;
    mount.hidden = false;
    updateRecsNav(mount);
  }

  function paintHits(mount, hits, pending) {
    var A = window.McmAlgolia;
    if (!A || !A.cardHtml || !hits.length) {
      paintRecs(mount, '');
      return;
    }
    paintRecs(mount, hits.map(function (hit) {
      var card = A.cardHtml(hit, { imageWidth: 480, pending: pending, deepEtch: true });
      if (!card) return '';
      return '<div class="mcm-drawer-recs__slide">' + card + '</div>';
    }).join(''));
    if (!pending && A.hydrateSwatches) A.hydrateSwatches(mount);
  }

  function fillDrawerRecs(mount) {
    var A = window.McmAlgolia;
    if (!A || !A.cardHtml || !A.enrich || !A.cartComplementHits) return;
    A.cartComplementHits(cartContext(mount), { limit: 8 }).then(function (hits) {
      if (!mount.isConnected) return;
      if (!hits.length) {
        paintRecs(mount, '');
        return;
      }
      paintHits(mount, hits, true);
      A.enrich(hits, '', 4).then(function (enriched) {
        paintHits(mount, enriched || hits, false);
      }).catch(function () {
        paintHits(mount, hits, false);
      });
    });
  }

  function bootDrawerRecs() {
    var A = window.McmAlgolia;
    if (!A || !A.cardHtml || !A.enrich || !A.cartComplementHits) return;
    document.querySelectorAll('[data-mcm-drawer-recs]').forEach(function (mount) {
      if (mount.getAttribute('data-booted') === '1') return;
      mount.setAttribute('data-booted', '1');
      fillDrawerRecs(mount);
    });
  }

  document.addEventListener('click', function (event) {
    var recsPrev = event.target.closest('[data-mcm-drawer-recs-prev]');
    var recsNext = event.target.closest('[data-mcm-drawer-recs-next]');
    if (recsPrev || recsNext) {
      event.preventDefault();
      var recs = recsPrev ? recsPrev.closest('[data-mcm-drawer-recs]') : recsNext.closest('[data-mcm-drawer-recs]');
      var recsList = recs && recs.querySelector('[data-mcm-drawer-recs-list]');
      if (!recsList) return;
      var recsSlide = recsList.querySelector('.mcm-drawer-recs__slide');
      var recsGap = parseFloat(getComputedStyle(recsList).columnGap || getComputedStyle(recsList).gap) || 0;
      var recsStep = recsSlide ? recsSlide.getBoundingClientRect().width + recsGap : recsList.clientWidth;
      recsList.scrollBy({ left: (recsPrev ? -1 : 1) * recsStep, behavior: 'smooth' });
      window.setTimeout(function () { updateRecsNav(recs); }, 350);
      return;
    }

    var prev = event.target.closest('[data-mcm-upsell-prev]');
    var next = event.target.closest('[data-mcm-upsell-next]');
    if (prev || next) {
      event.preventDefault();
      var root = rootOf(prev || next);
      var scroller = scrollerOf(root);
      if (!scroller) return;
      scroller.scrollBy({ left: (prev ? -1 : 1) * stepSize(scroller), behavior: 'smooth' });
      window.setTimeout(function () { updateNav(root); }, 350);
      return;
    }

    var choice = event.target.closest('[data-mcm-upsell-choice]');
    if (choice) {
      event.preventDefault();
      var item = choice.closest('[data-mcm-upsell-item]');
      var dataEl = item && item.querySelector('[data-mcm-upsell-variants]');
      if (!item || !dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (error) { return; }
      var variantId = Number(choice.getAttribute('data-variant-id'));
      var variant = variants.find(function (row) { return row.id === variantId; });
      if (!variant) return;
      item.querySelectorAll('[data-mcm-upsell-choice]').forEach(function (button) {
        button.classList.toggle('is-active', button === choice);
      });
      var add = item.querySelector('[data-mcm-upsell-add]');
      var price = item.querySelector('[data-mcm-upsell-price]');
      var lead = item.querySelector('[data-mcm-upsell-lead]');
      var image = item.querySelector('[data-mcm-upsell-image]');
      if (price) price.textContent = variant.price;
      if (image && variant.image) image.src = variant.image;
      if (lead) {
        lead.hidden = !variant.lead;
        lead.textContent = variant.lead ? 'Lead time: ' + variant.lead : '';
      }
      if (add) {
        add.setAttribute('data-variant-id', String(variant.id));
        add.setAttribute('data-lead', variant.lead || '');
        add.disabled = !variant.available;
        add.textContent = variant.available ? 'Add' : 'Sold out';
      }
      return;
    }

    var addButton = event.target.closest('[data-mcm-upsell-add]');
    if (!addButton || addButton.disabled) return;
    event.preventDefault();
    var id = Number(addButton.getAttribute('data-variant-id'));
    if (!id) return;
    addButton.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var page = document.querySelector('cart-section');
    var sections = [drawer, page].filter(Boolean).map(function (el) { return el.dataset.sectionId; }).filter(Boolean);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var item = { id: id, quantity: 1 };
    var leadTime = addButton.getAttribute('data-lead');
    if (leadTime) item.properties = { 'Lead time': leadTime };
    var payload = { items: [item] };
    if (sections.length) payload.sections = sections.join(',');

    function publish(sectionsMap) {
      document.dispatchEvent(new CustomEvent('cart:change', { detail: { sections: sectionsMap || {} } }));
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    }).then(function (result) {
      if (!result.ok) throw new Error('Could not add');
      var returned = result.data && result.data.sections;
      if (returned && Object.keys(returned).length) {
        publish(returned);
        return;
      }
      var sectionId = drawer && drawer.dataset.sectionId;
      if (!sectionId) return;
      return fetch(root + '?sections=' + encodeURIComponent(sectionId), { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(publish);
    }).catch(function () {
      addButton.disabled = false;
    });
  });

  document.addEventListener('scroll', function (event) {
    var scroller = event.target && event.target.closest && event.target.closest('[data-mcm-upsell-scroller]');
    if (scroller) updateNav(rootOf(scroller));
    var recsList = event.target && event.target.closest && event.target.closest('[data-mcm-drawer-recs-list]');
    if (recsList) updateRecsNav(recsList.closest('[data-mcm-drawer-recs]'));
  }, true);

  document.addEventListener('cart:change', function () {
    [80, 400].forEach(function (delay) {
      window.setTimeout(function () {
        ensureDrawerWatch();
        watch();
        bootDrawerRecs();
        updateAll();
      }, delay);
    });
  });
  window.addEventListener('resize', updateAll);

  var resizeObserver = window.ResizeObserver ? new ResizeObserver(updateAll) : null;
  function watch() {
    if (!resizeObserver) return;
    document.querySelectorAll('.cart-drawer [data-mcm-upsell-scroller]').forEach(function (el) {
      if (el.getAttribute('data-mcm-upsell-watched')) return;
      el.setAttribute('data-mcm-upsell-watched', '1');
      resizeObserver.observe(el);
    });
  }

  function ensureDrawerWatch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver || drawer.getAttribute('data-mcm-upsell-watched')) return;
    drawer.setAttribute('data-mcm-upsell-watched', '1');
    new MutationObserver(function () {
      window.setTimeout(function () {
        watch();
        bootDrawerRecs();
        updateAll();
      }, 30);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function boot() {
    watch();
    ensureDrawerWatch();
    bootDrawerRecs();
    updateAll();
  }

  function start() {
    boot();
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      boot();
      var waiting = document.querySelector('[data-mcm-drawer-recs]:not([data-booted])');
      if (!waiting || tries > 80) clearInterval(timer);
    }, 100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
